import React, { useContext } from 'react'
import CountOnLeftPanel from './CountOnLeftPanel'
import { Context } from 'Context/Context';
import { PROFESSIONAL } from 'Constants';

function PanelElement({activePanel, activeTab, setActivePanel, id, name, count}) {
  const {userDetails} = useContext(Context);
  const role = userDetails?.role;
  const isActive = parseInt(activePanel) === parseInt(id);
  const isDelete = name === "Delete Account";
  return (
    <div id={id} onClick={()=>setActivePanel(id)}
    className={
      'flex justify-between items-center w-full py-3 px-6 cursor-pointer border-l-2 transition-colors font-plexsans text-[13px] '
      + (isDelete
          ? (isActive
              ? ' border-[#9a3b2e] text-[#9a3b2e] font-semibold bg-[rgba(154,59,46,0.06)]'
              : ' border-transparent text-[rgba(154,59,46,0.75)] hover:text-[#9a3b2e] hover:bg-[rgba(154,59,46,0.06)]')
          : (isActive
              ? ' border-tan text-navy font-semibold bg-[rgba(138,98,49,0.06)]'
              : ' border-transparent font-normal text-[rgba(20,33,61,0.6)] hover:text-navy hover:bg-[rgba(138,98,49,0.04)]'))
    }>
      <div>
        {name}
      </div>
      {
        (count && parseInt(count) > 0) ?
        <div className='w-max ml-1  px-2 text-xs items-center flex justify-center  rounded-full text-ivory bg-tan'>{parseInt(count)>99 ? '99+' : count}</div>
        :
        <></>
      }
    </div>
  )
}

export default PanelElement